import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Logo from "../components/Logo";

export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get("email") || "");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }
    setSubmitting(true);
    try {
      await fetch("/api/forgot-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      setSent(true);
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-hero text-white flex flex-col">
      <div className="px-6 md:px-12 pt-7 flex items-center justify-between">
        <Logo size="sm" />
        <Link to="/login" className="text-xs text-white/50 hover:text-white">
          Back to sign in
        </Link>
      </div>

      <div className="flex-1 grid place-items-center px-6 md:px-12 py-10">
        <div className="w-full max-w-md glass-strong rounded-3xl p-8 md:p-10">
          <div className="text-[11px] tracking-[0.28em] uppercase text-[#D4AF37] mb-3">
            Password reset
          </div>

          {sent ? (
            <>
              <h1 className="font-display text-4xl leading-tight">Check your email.</h1>
              <p className="text-white/55 mt-3">
                If <span className="text-white/80">{email}</span> is registered, a reset link is on its way. Check your spam folder if it doesn't arrive within a few minutes.
              </p>
              <Link
                to="/login"
                className="mt-8 inline-block text-sm text-[#F2DE94] hover:text-white underline"
              >
                Back to sign in
              </Link>
            </>
          ) : (
            <>
              <h1 className="font-display text-4xl leading-tight">Recover your account.</h1>
              <p className="text-white/55 mt-3">
                Enter your email and we'll send a reset link.
              </p>

              <form onSubmit={handleSubmit} className="mt-6 space-y-4">
                <input
                  type="email"
                  placeholder="Email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 focus:outline-none focus:border-[rgba(212,175,55,0.5)] text-white placeholder:text-white/40"
                />

                {error && <div className="text-red-400 text-sm">{error}</div>}

                <button
                  type="submit"
                  disabled={submitting}
                  className={`w-full py-3 rounded-xl bg-[#D4AF37] text-black font-semibold transition-opacity ${submitting ? "opacity-60" : ""}`}
                >
                  {submitting ? "Sending…" : "Send reset link"}
                </button>
              </form>

              <p className="text-sm text-white/60 mt-6">
                Remember your password?{" "}
                <Link to="/login" className="text-[#F2DE94] hover:text-white">
                  Sign in
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
